/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { hooksServerNamesDeleteServerNameOverride } from "../funcs/hooksServerNamesDeleteServerNameOverride.js";
import { hooksServerNamesListServerNameOverrides } from "../funcs/hooksServerNamesListServerNameOverrides.js";
import { hooksServerNamesUpsertServerNameOverride } from "../funcs/hooksServerNamesUpsertServerNameOverride.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ServerNameOverride } from "../models/components/servernameoverride.js";
import {
  DeleteServerNameOverrideRequest,
  DeleteServerNameOverrideSecurity,
} from "../models/operations/deleteservernameoverride.js";
import {
  ListServerNameOverridesRequest,
  ListServerNameOverridesSecurity,
} from "../models/operations/listservernameoverrides.js";
import {
  UpsertServerNameOverrideRequest,
  UpsertServerNameOverrideSecurity,
} from "../models/operations/upsertservernameoverride.js";
import { unwrapAsync } from "../types/fp.js";

export class HooksServerNames extends ClientSDK {
  /**
   * delete hooksServerNames
   *
   * @remarks
   * Delete a server name display override
   */
  async deleteServerNameOverride(
    request: DeleteServerNameOverrideRequest,
    security?: DeleteServerNameOverrideSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(hooksServerNamesDeleteServerNameOverride(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * list hooksServerNames
   *
   * @remarks
   * List all server name display overrides for a project
   */
  async listServerNameOverrides(
    request?: ListServerNameOverridesRequest | undefined,
    security?: ListServerNameOverridesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<Array<ServerNameOverride>> {
    return unwrapAsync(hooksServerNamesListServerNameOverrides(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * upsert hooksServerNames
   *
   * @remarks
   * Create or update a server name display override
   */
  async upsertServerNameOverride(
    request: UpsertServerNameOverrideRequest,
    security?: UpsertServerNameOverrideSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ServerNameOverride> {
    return unwrapAsync(hooksServerNamesUpsertServerNameOverride(
      this,
      request,
      security,
      options,
    ));
  }
}
